import { FileDownload } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { actionIconStyle } from 'components/ActionUtil'
import ExportFileModal from 'components/modal/ExportFileModal'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'

const ExportChoice = ({ data }) => {
    const [openModal, setOpenModal] = useState(false)

    return (
        <Tooltip id={'export_choice_action_navbar'} title={i18n.export}>
            <FileDownload
                onClick={() => setOpenModal(true)}
                sx={{ ...actionIconStyle }}
            />
            <ExportFileModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                data={data.exportChoices}
                closeOnExport={!data.letModalOpen}
                groups={data.groups}
            />
        </Tooltip>
    )
}

ExportChoice.propTypes = {
    data: PropTypes.shape({
        exportChoices: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            group: PropTypes.number,
            settingsContent: PropTypes.element,
            formats: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                callback: PropTypes.func,
            })),
        })).isRequired,
        grouped: PropTypes.bool,
        groups: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.number,
            name: PropTypes.string,
        })),
        letModalOpen: PropTypes.bool,
    }).isRequired,
}

export default ExportChoice